<template>
  <div>
    <p>Please confirm that you want to update the order with this newly uploaded model</p>
    <button
      class="sw-dms-button sw-dms-button--big"
      title="Cancel and re-upload"
      @click="cancel">No, re-upload another model
    </button>
    <button
      class="sw-dms-button sw-dms-button--big sw-dms-button--red"
      title="Proceed with model"
      @click="submit">Yes
    </button>
  </div>
</template>

<script>
  import VueJQueryMixin from 'js/lib/vue/mixins/vue-jquery-mixin';

  export default {
    name: 'model-fix-confirm-uploaded-model',

    mixins: [VueJQueryMixin],

    props: {
      confirmUrl: {
        type: String,
        required: true
      }
    },

    methods: {
      submit() {
        const _this = this;
        this.$jQuery.ajax({
          type: 'POST',
          url: _this.confirmUrl,
          dataType: 'json',
          success: (data) => {
            _this.$emit('success', data);
          },
          error: (jqXHR) => {
            console.error('error', jqXHR);
            _this.$emit('error', jqXHR);
          }
        });
      },
      cancel() {
        this.$emit('cancel');
      }
    }
  }
</script>
